import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { ArrowUpRight } from "lucide-react";
import { fmtCurrency, fmtDateOrDash } from "../clientConstants";

const thCls = "text-[11px] font-semibold uppercase tracking-[0.1em] text-[#475467] bg-[#F7F9FC]";
const STATUS_LABEL = { draft: "Draft", sent: "Sent", partially_paid: "Partially Paid", paid: "Paid" };
const STATUS_BADGE = {
  draft: "bg-[#F1F5F9] text-[#475467] border-[#E2E8F0]",
  sent: "bg-[#E8F1FD] text-[#1D4E89] border-[#BFDBFE]",
  partially_paid: "bg-[#FFFBEB] text-[#D97706] border-[#FDE68A]",
  paid: "bg-[#ECFDF5] text-[#059669] border-[#A7F3D0]",
};

export function InvoicesPanel({ clientId, onOpenOrder }) {
  const [invoices, setInvoices] = useState(null);
  useEffect(() => { api.get(`/admin/clients/${clientId}/invoices`).then((r) => setInvoices(r.data)).catch(() => setInvoices([])); }, [clientId]);
  if (invoices === null) return <div className="text-sm text-slate-400 py-10 text-center">Loading invoices…</div>;
  if (!invoices.length) return <div data-testid="client-invoices-empty" className="text-sm text-slate-400 py-10 text-center border border-dashed border-slate-200 rounded-lg">No invoices yet for this client.</div>;
  return (
    <div data-testid="client-invoices-panel" className="rounded-lg border border-[#E4E9F0] overflow-x-auto shadow-sm">
      <Table>
        <TableHeader><TableRow><TableHead className={thCls}>Invoice #</TableHead><TableHead className={thCls}>Date</TableHead><TableHead className={thCls}>Due</TableHead><TableHead className={thCls}>Amount</TableHead><TableHead className={thCls}>Paid</TableHead><TableHead className={thCls}>Balance</TableHead><TableHead className={thCls}>Status</TableHead><TableHead className={thCls}></TableHead></TableRow></TableHeader>
        <TableBody>
          {invoices.map((inv) => (
            <TableRow key={inv.booking_id} data-testid={`client-invoice-row-${inv.booking_id}`} className="hover:bg-[#F8FAFC] transition-colors">
              <TableCell className="font-mono text-xs font-bold text-[#101828]">{inv.invoice_number || "—"}</TableCell>
              <TableCell className="text-sm whitespace-nowrap text-[#475467]">{fmtDateOrDash(inv.created_at)}</TableCell>
              <TableCell className="text-sm whitespace-nowrap text-[#475467]">{fmtDateOrDash(inv.due_date)}</TableCell>
              <TableCell className="text-sm font-semibold text-[#101828]">{fmtCurrency(inv.total)}</TableCell>
              <TableCell><span className="text-sm font-semibold text-emerald-700 bg-emerald-50 px-2 py-0.5 rounded border border-emerald-200">{fmtCurrency(inv.paid)}</span></TableCell>
              <TableCell className="text-sm font-bold text-[#0C2347]">{fmtCurrency(inv.balance)}</TableCell>
              <TableCell><span className={`text-[11px] font-semibold tracking-wide px-2.5 py-0.5 rounded-full border ${STATUS_BADGE[inv.status] || "bg-slate-100 text-slate-600 border-slate-300"}`}>{STATUS_LABEL[inv.status] || inv.status}</span></TableCell>
              <TableCell><Button data-testid={`client-invoice-view-${inv.booking_id}`} variant="ghost" size="sm" className="rounded-lg text-xs font-semibold gap-1 hover:bg-[#0C2347] hover:text-white transition-colors" onClick={() => onOpenOrder(inv.booking_id, "invoice")}>View <ArrowUpRight size={13} /></Button></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
